'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _defaultStyles = require('../default-styles');

var _defaultStyles2 = _interopRequireDefault(_defaultStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var overrideStyles = {
  body: {
    maxWidth: '40em'
  },
  compact: {
    maxWidth: 'calc(100% - 40px)'
  },
  link: {
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    textDecoration: 'underline'
  },
  mention: {
    color: _colors2.default.theme,
    fontSize: 'inherit',
    fontWeight: 'bolder'
  }
};

exports.default = (0, _merge2.default)({}, _defaultStyles2.default, overrideStyles);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message/text-message/styles.js
// module id = 298
// module chunks = 0